export const userTypes = [
  { label: "Artist", value: "artist" },
  {
    label:
      "Museum",
    value: "museum",
  },
  {
    label:
      "Auction House",
    value: "auction_house",
  },
  {
    label:
      "Private Collection",
    value: "private_collection",
  },
  {
    label:
      "Art Gallery",
    value: "art_gallery",
  },
  {
    label:
      "NFT Agency",
    value: "nft_agency",
  },
  {
    label:
      "Fairs",
    value: "fairs",
  },
  {
    label: "Festival",
    value: "festival",
  },
  { label: "Other (please specify)", value: "other" },
];
export const generalFocus = [
  { label: "Physical Artwork", value: "physical_artwork" },
  { label: "Digital Artwork", value: "digital_artwork" },
  { label: "Commision Art", value: "commision_art" },
  { label: "Collaboration with other Artists", value: "collaboration" },
  { label: "Participation in large group exhibition", value: "participation" },
  { label: "Community building and social media promotion", value: "community" },
  { label: "Other", value: "other" },
];
